export default {
  freelancerToolkit: [
    {
      name: `Freelancer Toolkit`,
      description: `A Twine curated collection of essential tools and services for creative and digital freelancers.`,
      link: `https://link.twine.fm/PortfolioFreelancerToolkit`,
      linkCta: `See more`,
      logo: `freelancer-toolkit-logo.webp`,
      includeName: true,
      background: `#343260`,
    },
  ],
  worldExcludingAmericaUnitedKingdomAustraliaNewZealand: [
    {
      name: `1password`,
      description: `1Password is the easiest way to create, save, and share strong passwords, log in to sites, and protect your privacy.`,
      link: `https://www2.twine.net/1PasswordExJobs`,
      linkCta: `Try it free`,
      logo: `1password-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `bubble`,
      description: `Design, develop, and launch web apps without any code. Whether you're just starting out or a professional, Bubble is for everyone. `,
      link: `https://www2.twine.net/BubbleExJobs`,
      linkCta: `Learn how to start for free`,
      logo: `bubble-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `wix`,
      description: `Connect with experienced freelancers and grow your web design business with hands-on, personalized support.`,
      link: `https://www2.twine.net/WixExJobs`,
      linkCta: `Join the community`,
      logo: `wix-logo-ff.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `tldv`,
      description: `AI Meeting Insights beyond simple recordings, transcripts, and summaries.`,
      link: `https://www2.twine.net/tldvExJobs`,
      linkCta: `Try for free here ✨`,
      logo: `tldv-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `tldv2`,
      description: `AI Meeting Insights beyond simple recordings, transcripts, and summaries.`,
      link: `https://www2.twine.net/tldvExJobs`,
      linkCta: `Try for free here ✨`,
      logo: `tldv-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `kerika`,
      description: `Kerika is how Twine's freelancers and clients get more done, with task management and team collaboration.`,
      link: `https://www2.twine.net/KerikaExJobs`,
      linkCta: `Get a 30-day free trial!`,
      logo: `kerika-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `kittl`,
      description: `Unleash your creativity with the next-generation web-based design tool, Kittl. Join over 3 million creatives using it already!`,
      link: `https://www2.twine.net/KittlExJobs`,
      linkCta: `Try it for free, or get 25% off with code TWINE`,
      logo: `kittl-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `printful`,
      description: `Design and sell custom products online with print-on-demand dropshipping. No upfront costs, no order minimums, no inventory.`,
      link: `https://www2.twine.net/PrintfulExJobs1`,
      linkCta: `Sign up for $0`,
      logo: `printful-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `printful2`,
      description: `Don't keep your talent to yourself—design over 330 products with your artwork and sell them online without inventory.`,
      link: `https://www2.twine.net/PrintfulExJobs2`,
      linkCta: `Start for $0`,
      logo: `printful-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `weTransfer`,
      description: `Move it like a Pro. You focus on being a creative prodigy. WeTransfer will ensure your work is shared smoothly, safely, and looking sharp.`,
      link: `https://www2.twine.net/WeTransferExJobs`,
      linkCta: `Get 30% off a WeTransfer plan`,
      logo: `wetransfer-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
  ],
  globalExcludingIndiaPakistanIraqKenyaNigeriaIran: [],
  usOnly: [
    {
      name: `current`,
      description: `Switch your direct deposit to get paid up to 2 days faster, earn up to 4.00% on your savings, and build credit safely.`,
      link: `https://www2.twine.net/CurrentExJobs`,
      linkCta: `Switch now`,
      logo: `current-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `honeybook`,
      description: `Bring together invoices, CRM, proposals, contracts and payments all in one place with HoneyBook. Use code twine55_hb for 55% off all plans.`,
      link: `https://www2.twine.net/HoneyBookExJobs`,
      linkCta: `Use your code here`,
      logo: `honeybook-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `honeybook2`,
      description: `Bring together invoices, CRM, proposals, contracts and payments all in one place with HoneyBook. Use code twine55_hb for 55% off all plans.`,
      link: `https://www2.twine.net/HoneyBookExJobs`,
      linkCta: `Use your code here`,
      logo: `honeybook-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `tldv`,
      description: `AI Meeting Insights beyond simple recordings, transcripts, and summaries.`,
      link: `https://www2.twine.net/tldvExJobs`,
      linkCta: `Try for free here ✨`,
      logo: `tldv-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `tldv2`,
      description: `AI Meeting Insights beyond simple recordings, transcripts, and summaries.`,
      link: `https://www2.twine.net/tldvExJobs`,
      linkCta: `Try for free here ✨`,
      logo: `tldv-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `wix`,
      description: `Connect with experienced freelancers and grow your web design business with hands-on, personalized support.`,
      link: `https://www2.twine.net/WixPortfolio`,
      linkCta: `Join the community`,
      logo: `wix-logo-ff.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `kerika`,
      description: `Kerika is how Twine's freelancers and clients get more done, with task management and team collaboration.`,
      link: `https://www2.twine.net/KerikaExJobs`,
      linkCta: `Get a 30-day free trial!`,
      logo: `kerika-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `weTransfer`,
      description: `Move it like a Pro. You focus on being a creative prodigy. WeTransfer will ensure your work is shared smoothly, safely, and looking sharp.`,
      link: `https://www2.twine.net/WeTransferExJobs`,
      linkCta: `Get 30% off a WeTransfer plan`,
      logo: `wetransfer-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
  ],
  eeaOnly: [
    {
      name: `1password`,
      description: `1Password is the easiest way to create, save, and share strong passwords, log in to sites, and protect your privacy.`,
      link: `https://www2.twine.net/1PasswordExJobs`,
      linkCta: `Try it free`,
      logo: `1password-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `bubble`,
      description: `Design, develop, and launch web apps without any code. Whether you're just starting out or a professional, Bubble is for everyone. `,
      link: `https://www2.twine.net/BubbleExJobs`,
      linkCta: `Learn how to start for free`,
      logo: `bubble-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `wix`,
      description: `Connect with experienced freelancers and grow your web design business with hands-on, personalized support.`,
      link: `https://www2.twine.net/WixExJobs`,
      linkCta: `Join the community`,
      logo: `wix-logo-ff.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `tldv`,
      description: `AI Meeting Insights beyond simple recordings, transcripts, and summaries.`,
      link: `https://www2.twine.net/tldvExJobs`,
      linkCta: `Try for free here ✨`,
      logo: `tldv-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `tldv2`,
      description: `AI Meeting Insights beyond simple recordings, transcripts, and summaries.`,
      link: `https://www2.twine.net/tldvExJobs`,
      linkCta: `Try for free here ✨`,
      logo: `tldv-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `kerika`,
      description: `Kerika is how Twine's freelancers and clients get more done, with task management and team collaboration.`,
      link: `https://www2.twine.net/KerikaExJobs`,
      linkCta: `Get a 30-day free trial!`,
      logo: `kerika-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `kittl`,
      description: `Unleash your creativity with the next-generation web-based design tool, Kittl. Join over 3 million creatives using it already!`,
      link: `https://www2.twine.net/KittlExJobs`,
      linkCta: `Try it for free, or get 25% off with code TWINE`,
      logo: `kittl-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `printful`,
      description: `Design and sell custom products online with print-on-demand dropshipping. No upfront costs, no order minimums, no inventory.`,
      link: `https://www2.twine.net/PrintfulExJobs1`,
      linkCta: `Sign up for $0`,
      logo: `printful-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `printful2`,
      description: `Don't keep your talent to yourself—design over 330 products with your artwork and sell them online without inventory.`,
      link: `https://www2.twine.net/PrintfulExJobs2`,
      linkCta: `Start for $0`,
      logo: `printful-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `weTransfer`,
      description: `Move it like a Pro. You focus on being a creative prodigy. WeTransfer will ensure your work is shared smoothly, safely, and looking sharp.`,
      link: `https://www2.twine.net/WeTransferExJobs`,
      linkCta: `Get 30% off a WeTransfer plan`,
      logo: `wetransfer-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
  ],
  ukOnly: [
    {
      name: `brookson`,
      description: `Intouch Freelancing enables freelancers to enhance their tax savings and boost their overall earnings.`,
      link: `https://www2.twine.net/BrooksonExJobs`,
      linkCta: `Find out what changes affect you`,
      logo: `intouch-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `gorilla`,
      description: `Keep being creative and let Gorilla handle the finances with specialist accountants for creative freelancers. `,
      link: `https://www2.twine.net/GorillaExJobs`,
      linkCta: `Get in touch`,
      logo: `gorilla-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
    {
      name: `kittl`,
      description: `Unleash your creativity with the next-generation web-based design tool, Kittl. Join over 3 million creatives using it already!`,
      link: `https://www2.twine.net/KittlExJobs`,
      linkCta: `Try it for free, or get 25% off with code TWINE`,
      logo: `kittl-logo.svg`,
      includeName: false,
      background: `#ffffff`,
    },
  ],
  germanyOnly: [],
  australiaOnly: [
    {
      name: `hnry`,
      description: `Never think about tax again.`,
      link: `https://www2.twine.net/HnryExJobs`,
      linkCta: `Join Now`,
      logo: `hnry-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
  ],
  newZealandOnly: [
    {
      name: `hnry`,
      description: `Never think about tax again.`,
      link: `https://www2.twine.net/HnryExJobs`,
      linkCta: `Join Now`,
      logo: `hnry-logo.png`,
      includeName: false,
      background: `#ffffff`,
    },
  ],
};

// eslint-disable-next-line no-unused-vars
const advertObjectTemplate = [
  {
    name: ``,
    description: ``,
    link: ``,
    linkCta: ``,
    logo: ``,
    includeName: false,
    background: `#ffffff`,
  },
];
